import SideNavButtonOld from '@/features/navigation/side-nav/sideNavButtonOld';

import { useGetSideNavButtons } from '../side-nav/hooks/useGetSideNavButtons';
import { MobileNavHeader } from './mobileNavHeader';

export const MobileSideNav = () => {
  const sideNavButtons = useGetSideNavButtons();

  return (
    <div className="px-6">
      <MobileNavHeader />
      <div className="flex flex-wrap gap-x-4 gap-y-4 overflow-auto scrollbar-hide">
        {sideNavButtons.map((sideNavButton) => {
          return (
            <SideNavButtonOld key={sideNavButton.navId} {...sideNavButton} />
          );
        })}
      </div>
    </div>
  );
};
